module.exports = __webpack_public_path__ + "img/hamburger-lines.53e354e9.svg";